import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useStore } from "../store/useStore";
import { BigKeyboard } from "../components/BigKeyboard";
import { t } from "../lib/i18n";
import { LANGUAGES } from "../data/languages";

export default function NameInput() {
  const lang = useStore((s) => s.language);
  const setName = useStore((s) => s.setName);
  const customerName = useStore((s) => s.customerName);
  const navigate = useNavigate();
  const [val, setVal] = useState(customerName);
  const isRtl = LANGUAGES.find((l) => l.code === lang)?.rtl;

  const submit = () => {
    if (val.trim().length < 2) return;
    setName(val.trim());
    navigate("/kiosk/upsell");
  };

  return (
    <div
      className="grain min-h-screen w-full bg-paper flex flex-col items-center px-8 pt-10 pb-6 relative"
      dir={isRtl ? "rtl" : undefined}
    >
      <span className="absolute top-4 left-6 font-mono text-xs tracking-widest text-ink/40">{t(lang, "name_form_label")}</span>
      <span className="absolute top-4 right-6 font-mono text-xs tracking-widest text-ink/40">{t(lang, "name_required")}</span>

      <p className="font-mono text-xs tracking-[0.4em] text-mezcal uppercase mb-2">{t(lang, "name_caption")}</p>
      <h1 className="font-display font-black text-5xl text-center max-w-3xl tracking-kerned leading-[0.9]">
        {t(lang, "name_title")}
      </h1>
      <p className="font-hand text-xl text-cactus mt-1">— {t(lang, "name_handwritten")} —</p>

      <div
        className="mt-6 w-full max-w-lg bg-paper border-4 border-ink relative shadow-[0_8px_24px_-8px_rgba(26,22,18,0.4)]"
        style={{ transform: "rotate(-1.5deg)" }}
      >
        <div className="bg-mezcal text-paper text-center py-1.5">
          <div className="font-display font-bold tracking-[0.3em] uppercase text-sm">{t(lang, "name_tag")}</div>
        </div>
        <div className="px-6 py-5 text-center min-h-[88px] flex items-center justify-center">
          <span className="text-5xl font-display font-bold tracking-tight">
            {val || <span className="text-ink/20">···</span>}
            <span className="inline-block w-1 h-10 bg-ink ml-1 align-middle animate-pulse" />
          </span>
        </div>
      </div>

      <div className="mt-6 w-full">
        <BigKeyboard value={val} onChange={setVal} onSubmit={submit} />
      </div>

      <div className="mt-4 flex gap-3 w-full max-w-lg">
        <button
          onClick={() => navigate(-1)}
          className="flex-1 py-3 rounded-sm border-2 border-ink/30 font-display font-bold tracking-wide"
        >
          ← {t(lang, "back")}
        </button>
        <button
          disabled={val.trim().length < 2}
          onClick={submit}
          className="flex-[2] py-3 rounded-sm bg-mezcal disabled:opacity-30 text-paper font-display font-bold tracking-wide"
        >
          {t(lang, "continue")} →
        </button>
      </div>
    </div>
  );
}
